module.exports = __webpack_public_path__ + "static/media/image_partners_albi.13eb3d3e.jpg";